import { createStoreContext } from "ariakit-utils/store";

import { PaginationState } from "./pagination-state";

export const PaginationContextState = createStoreContext<PaginationState>();
